<script setup>
    /**
     * Vue Scripts
     */
    import {onMounted, ref} from "vue";
    import {ModalsContainer, useModal} from 'vue-final-modal'

    /**
     * Vue Component
     */
    import Modal from "@component/Modal/Modal.vue";

    const goToUrl = ref('');
    const siteUrl = window.location.host;
    const {confirm, content, deny} = GLOBAL.externalModal;
    const modalId = 'vue-external-modal'

    /**
     * Validates the href passed to the function
     * @param {string} url The URL passed to the function
     * @returns {boolean}
     */
    const validateUrl = (url) => /^(https?):\/\/[^\s/$.?#].[^\s]*$/i.test(url);

    /**
     * Fetch all the anchor links on the page
     */
    const allAnchors = Array.from(document.getElementsByTagName('a'));

    /**
     * Strings of links that aren't to be filtered out
     */
    const filterOutArray = [
        'javascript',
        'mailto',
        'merck.com',
        'merckoncologyclinicaltrials.com',
        'merckclinicaltrials.com',
        'tel'
    ];

    /**
     * Closes the modal after an action
     * and removes the goToUrl value
     */
    const closeModal = () => {
        goToUrl.value = '';
        close();
    }

    /**
     * Modal Setup
     */
    const {open, close} = (useModal({
        component: Modal,
        attrs: {
            clickToClose: true,
            escToClose: true,
            focusTrap: true,

            content,
            confirmText: confirm,
            denyText: deny,
            modalId,
            onConfirm() {
                window.open(goToUrl.value)
                closeModal()
            },
            onDeny() {
                closeModal()
            }
        },
    }))

    /**
     * Checks the URL if it is in the array of urls to not trigger the popup
     * @param {Object} link The HTML Object
     * @param {Array} urlsArray The array of URLs to check from
     * @returns {*}
     */
    const linkContainsArrayString = (link, urlsArray) => {
        if (!link?.href) return false;

        return urlsArray.some(stringFromArray => link.href.includes(stringFromArray)) || link.href.includes('#');
    };

    /**
     * Grab all the anchors and add an event listener to trigger
     * the modal to appear if they match
     */
    const processAnchors = () => {
        const externalAnchorLinks = allAnchors
            .filter(elm => {
                const href = elm?.href;
                return href && validateUrl(href) &&
                    new URL(href).host !== siteUrl &&
                    !linkContainsArrayString(elm, filterOutArray) &&
                    !elm.classList.contains('no-external-modal');
            });

        externalAnchorLinks.forEach(elm => {
            elm.addEventListener('click', (el) => {
                el.preventDefault();
                goToUrl.value = elm.href
                open()
            })
        });
    }

    /**
     * Sets up an observer that registers the anchor link processing to
     * trigger the modal to appear if applicable
     * @type {MutationObserver}
     */
    // const observer = new MutationObserver(mutations => mutations
    //     .some(mutation => mutation.addedNodes.length > 0) && processAnchors())

    /**
     * Execute when the component is mounted
     */
    onMounted(() => {
        setTimeout(processAnchors, 1000);
        // observer.observe(document.body, { childList: true, subtree: true });
    })
</script>

<template>
    <ModalsContainer />
</template>

<script>
    export default {
        name: "External Link Modal"
    }
</script>

<style lang="scss" scoped>

</style>
